(function() {
  if (window.__deliveryTooltipInit) return;
  window.__deliveryTooltipInit = true;

  var hoverTimer;

  function closeBubble(bubble) {
    bubble.classList.remove('is-visible', 'delivery-tooltip_bubble--above');
  }

  function closeAll(except) {
    document.querySelectorAll('.delivery-tooltip_bubble.is-visible').forEach(function(b) {
      if (b !== except) closeBubble(b);
    });
  }

   function positionBubble(bubble) {
    // Reset previous positioning states
    bubble.classList.remove('delivery-tooltip_bubble--above');
    bubble.style.right = '0';
    bubble.style.removeProperty('--arrow-right');
    
    bubble.classList.add('is-visible');

    var rect = bubble.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var margin = 8;

    // Vertical adjustment
    if (rect.bottom > viewportHeight - 16) {
      bubble.classList.add('delivery-tooltip_bubble--above');
    }

    // Horizontal adjustment
    if (rect.left < margin) {
      // Overflowing left: push it right by making 'right' negative
      var shiftRight = margin - rect.left;
      bubble.style.right = -shiftRight + 'px';
      bubble.style.setProperty('--arrow-right', (8 + shiftRight) + 'px');
    } else if (rect.right > viewportWidth - margin) {
      // Overflowing right: push it left by making 'right' positive
      var shiftLeft = rect.right - (viewportWidth - margin);
      bubble.style.right = shiftLeft + 'px';
      bubble.style.setProperty('--arrow-right', (8 - shiftLeft) + 'px');
    }
  }

  /* Click: toggle on trigger, close on outside */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.delivery-tooltip_trigger');

    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var bubble = trigger.nextElementSibling;

      if (bubble.classList.contains('is-visible')) {
        closeBubble(bubble);
      } else {
        closeAll(bubble);
        positionBubble(bubble);
      }
      return;
    }

    if (!e.target.closest('.delivery-tooltip_bubble')) {
      closeAll();
    }
  });

  /* Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Desktop hover: open on trigger mouseenter */
  document.addEventListener('mouseenter', function(e) {
    var trigger = e.target.closest('.delivery-tooltip_trigger');
    if (!trigger || 'ontouchstart' in window) return;
    clearTimeout(hoverTimer);
    var bubble = trigger.nextElementSibling;
    closeAll(bubble);
    positionBubble(bubble);
  }, true);

  /* Desktop hover: close on tooltip mouseleave with delay */
  document.addEventListener('mouseleave', function(e) {
    var tooltip = e.target.closest('.delivery-tooltip');
    if (!tooltip || 'ontouchstart' in window) return;
    hoverTimer = setTimeout(function() {
      var bubble = tooltip.querySelector('.delivery-tooltip_bubble');
      if (bubble) closeBubble(bubble);
    }, 200);
  }, true);

  /* Desktop hover: cancel close when entering bubble */
  document.addEventListener('mouseenter', function(e) {
    if (e.target.closest('.delivery-tooltip_bubble')) {
      clearTimeout(hoverTimer);
    }
  }, true);
})();
